var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-content-start slide"},[_c('div',{staticClass:"packet-title"},[_c('div',{staticClass:"demo-title"},[_c('h3',[_vm._v("ЖИШЭЭ БАГЦ: "+_vm._s(_vm.classify[_vm.category - 1].text))])])]),_c('div',{staticClass:"task-level-list"},_vm._l((_vm.levels.taskLevelArray),function(negLevel,index){return _c('div',{key:index,class:{ 'router-link': true }},[_c('div',{staticClass:"test-card",class:{
          locked: negLevel.isLocked,
          'test-one': index === 7,
          'test-two': index === 15,
          'test-three': index === 23,
          'card-second': index > 7,
          'card-third': index > 15,
        }},[_c('b-link',{staticClass:"card-btn",attrs:{"disabled":negLevel.isLocked,"to":{
            name: _vm.choice[_vm.levels.taskLevelArray[index].type],
            params: { lid: negLevel.order },
          }}},[_c('div',{class:{
              'task-number': _vm.levels.taskLevelArray[index].type === 0,
              'test-title': _vm.levels.taskLevelArray[index].type === 1,
            }},[(_vm.levels.taskLevelArray[index].type === 1)?_c('span',{class:{
                test1: index === 7,
                test2: index === 15,
                test3: index === 23,
              }},[_c('a',[_vm._v("СОРИЛ "+_vm._s(_vm.levels.taskLevelArray[index].order))])]):_vm._e(),_c('a',[_vm._v(" "+_vm._s(_vm.levels.taskLevelArray[index].order)+" ")])]),_c('img',{staticClass:"lock",attrs:{"src":require("../assets/images/lock.png")}}),_c('div',{staticClass:"star-container"},_vm._l((_vm.rating),function(i,index){return _c('div',{key:index},[_c('b-icon',{class:{
                  'red-star': i === 1 || i === 2,
                },attrs:{"icon":_vm.ic_on[i]}})],1)}),0)])],1)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }